import {toGregorian,toJalaali} from 'jalaali-js';

export const GregorianToPersian = (gregorianDate: string|Date) => {
    let x;
    if (typeof gregorianDate === 'string')
        x = new Date(gregorianDate);
    else
        x = gregorianDate;
    const xs = x.toISOString().split('T')[0].split('-');
    const d = toJalaali(parseInt(xs[0]),parseInt(xs[1]),parseInt(xs[2]));
    return `${d.jy}-${d.jm < 10 ? `0${d.jm}` : d.jm}-${d.jd < 10 ? `0${d.jd}` : d.jd}`;
};

export const PersianToGregorian = (persianDate: string) => {
    const x = persianDate.split('-');
    const d = toGregorian(parseInt(x[0]),parseInt(x[1]),parseInt(x[2]));
    return `${d.gy}-${d.gm < 10 ? `0${d.gm}` : d.gm}-${d.gd < 10 ? `0${d.gd}` : d.gd}`;
}

export const TimeFixToGoLayout = (time:string) => {
    // `2000-1-10 1:25:30` or `3:12:20`
    const d = time.split(" ");
    if(d.length === 2){
        const x = d[1].split(":");
        const l = x.length;
        const h = l > 0 ? parseInt(x[0]) : 0;
        const m = l > 1 ? parseInt(x[1]) : 0;
        const s = l > 2 ? parseInt(x[2]) : 0;

        const date = d[0].split("-");
        const year = date[0];
        const month = parseInt(date[1]);
        const day = parseInt(date[2]);

        return `${year}-${month > 9 ? month : `0${month}`}-${day > 9 ? day : `0${day}`} ${h > 9 ? h : `0${h}`}:${m > 9 ? m : `0${m}`}:${s > 9 ? s : `0${s}`}`
    } else {
        const x = time.split(":");
        const l = x.length;
        const h = l > 0 ? parseInt(x[0]) : 0;
        const m = l > 1 ? parseInt(x[1]) : 0;
        const s = l > 2 ? parseInt(x[2]) : 0;
        return `${h > 9 ? h : `0${h}`}:${m > 9 ? m : `0${m}`}:${s > 9 ? s : `0${s}`}`
    }
};

export const DateFixToGoLayout = (date:string) => {
    // `2000-1-10` => `2000-01-10`

    const x = date.split("-");
    if(x.length !== 3)
        return '';
    const year = x[0];
    const month = parseInt(x[1]);
    const day = parseInt(x[2]);

    return `${year}-${month > 9 ? month : `0${month}`}-${day > 9 ? day : `0${day}`}`
};